<template>
  <Page>
    <template #right>
      <van-count-down
        ref="countDown"
        :time="time"
        format="sss"
        @finish="countdownfinish"
      />
    </template>
    <div class="code-search">
        <van-cell-group>
            <van-field v-model="code" placeholder="请输入单号后5位" />
        </van-cell-group>
        <!-- <van-button type="primary" size="large" @click="submit" :disabled="code.length < 5">查询</van-button> -->
         <div class="keyboard">
            <van-number-keyboard
              :show="showKeyboard"
              theme="custom"
              :extra-key="['清除']"
              close-button-text="查询"
              @input="onInput"
              @close="submit"
              @delete="onDelete"
            />
        </div>
    </div>
  </Page>
</template>

<script>
import { getByCode } from "@/apis/index";
// import cellInput from "@/components/cellInput";
import { mapState } from "vuex";
import { mobileReg } from "@/utils/validate";
import { playVoice } from "@/utils";
import { Toast } from 'vant';

export default {
  components: {
    // cellInput
  },
  data() {
    return {
      code: "",
      form: {
        secret: ""
      },
      showKeyboard: true,
      focusKey: "phone",
      time: 120 * 1000
    };
  },
  mounted() {
    // setTimeout(() => this.playTips(), 2000);
    playVoice("请输入单号后5位进行查询")
  },
  computed: {
    ...mapState(["stationInfo"])
  },
  methods: {
    countdownfinish() {
      this.$router.push("/");
    },
    async submit() {
        if(this.code.length !== 5) {
            Toast.fail('请输入5位单号');
            return;
        }
        Toast.loading('查询中...');
        const res = await getByCode(this.code);
        Toast.clear();
        if(res && res.length > 0) {
            const pk = res[0];
            this.$router.push({
                path: "/user/pick-list",
                query: {
                    secret: pk.secret,
                }
            });
        } else {
            Toast.fail('没有数据');
        }
    },
    onInput(v) {
      console.log(v);
      if(v === "清除") {
        this.code = "";
      }
      if([0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(v)) {
        this.code = this.code + v;
      }
    },
    onDelete() {
      this.code = this.code.slice(0, this.code.length - 1);
    }
  }
};
</script>

<style lang="scss">
.code-search {
    height: 100%;
    padding: 0 15%;
    padding-top: rem(30);
    background-color: #f4f4f4;
    .van-cell-group {
        background-color: transparent;
    }
    .van-field {
        font-size: rem(60);
        font-weight: 500;
        border: 2px solid #d9d9d9;
        padding: rem(30);
        input {
            text-align: center;
        }
    }
    .van-button {
        height: rem(80);
        font-size: rem(40);
    }
    .keyboard {
      width: 60%;
      margin: 0 auto;
      padding-top: rem(40);
      .van-number-keyboard {
        position: static;
        transform: scale(1.2);
        .van-key {
          font-size: rem(30);
        }
      }
    }
}
</style>
